<template>
  <app-modal name="invoice-paid-modal" :title="title" @before-open="beforeOpen" :is-submitting="isLoading" @before-close="beforeClose"  width="30%" :submitOnEnter="false" @on-ok="onOk">
    <div class="paid-modal-content">
      <div class="paid-modal-information">
        <p v-html="generateInvoices"></p>
        <p v-show="generateTotalWithoutTax">{{ this.$t('invoice.totalBeforeTax') }}: <strong>{{ generateTotalWithoutTax | formatNumber('currency') }}</strong></p>
        <p v-show="generateTotalWithTax">{{ this.$t('invoice.totalPaymentAmount') }}: <strong>{{ generateTotalWithTax | formatNumber('currency') }}</strong></p>
      </div>
      <app-form
        ref="form"
        @on-submit="onSubmit"
        :schema="schema"
        :data="formModel"
      />
    </div>
  </app-modal>
</template>

<script>
import AppModal from '@/components/app-modal/';
import AppForm from '@/components/app-form/';
import { mapActions, mapState } from 'vuex';
import { regexEmail } from '@/utils/regex';

export default {
  name: 'InvoicePaidModal',
  components: {
    AppForm,
    AppModal,
  },
  data() {
    return {
      title: this.$t('invoice.paidDate'),
      isLoading: false,
      schema: [
        {
          name: 'date_confirm',
          label: this.$t('invoice.paidDate'),
          placeholder: `${this.$t('app.enter')} ${this.$t('invoice.paidDate')}`,
          validation: 'required',
          type: 'datepicker',
        },
        {
          name: 'email',
          label: this.$t('invoice.confirmEmailSupplier'),
          placeholder: `${this.$t('app.enter')} ${this.$t('invoice.emailSupplier')}`,
          asyncValidation(value, resolve) {
            if (value.length === 0) {
              resolve(true);
            }

            const isValid = value.every((item, index) => {
              if (!regexEmail.test(item.text)) {
                resolve({ msg: `${this.$t('error.form.email.validate')} ${index + 1}` });
                return false;
              }
              return true;
            });

            if (isValid) {
              resolve(true);
            }
          },
          type: 'tag',
        },
      ],
      formModel: {
        date_confirm: '',
        email: [],
      },
      totalInvoices: {
        debt: 0,
        receivable_debt: 0,
      },
      invoicesId: new Set(),
      markedInvoices: new Map(),
    };
  },
  created() {
    const totalInvoices = JSON.parse(localStorage.getItem('totalInvoices'));
    if (!totalInvoices) {
      return;
    }
    if (totalInvoices.debt && !isNaN(totalInvoices.debt)) {
      this.totalInvoices.debt = totalInvoices.debt;
    }
    if (totalInvoices.receivable_debt && !isNaN(totalInvoices.receivable_debt)) {
      this.totalInvoices.receivable_debt = totalInvoices.receivable_debt;
    }
  },
  computed: {
    ...mapState(['companyMarked']),
    checkData() {
      return this.invoicesId.size === this.markedInvoices.size;
    },
    generateInvoices() {
      const strArr = [];
      if (this.checkData && this.markedInvoices.size) {
        this.markedInvoices.forEach(invoice => strArr.push(invoice.invoice_number));
      }
      return `${this.$t('invoice.youHaveChosenToPay')} <strong> ${this.markedInvoices.size} </strong> ${this.$t('invoice.invoiceNumber3')}: <strong>${strArr.join(', ')}</strong>`;
    },
    generateTotalWithTax() {
      let total = 0;
      if (!this.checkData || this.markedInvoices.size === 0) {
        return total;
      }
      this.markedInvoices.forEach((invoice) => {
        if (!isNaN(invoice.total_amount_with_tax)) {
          total += Number(invoice.total_amount_with_tax);
        }
      });
      return total;
    },
    generateTotalWithoutTax() {
      let total = 0;
      if (!this.checkData || this.markedInvoices.size === 0) {
        return total;
      }
      this.markedInvoices.forEach((invoice) => {
        if (!isNaN(invoice.total_amount_without_tax)) {
          total += Number(invoice.total_amount_without_tax);
        }
      });
      return total;
    },
  },
  methods: {
    ...mapActions(['setPaidDate', 'setState']),
    onSubmit(formModel) {
      this.$refs.form.validate().then((isValid) => {
        if (isValid) {
          this.isLoading = true;
          let emails = '';
          if (formModel.email && formModel.email.length > 0) {
            emails = formModel.email.map(item => item.text).join(';');
          }
          const totalInvoices = this.totalInvoices;
          const numberInvoices = [...this.invoicesId].length;
          this.setPaidDate({
            emails,
            date_confirm: formModel.date_confirm,
            invoices_id: this.invoicesId,
            vendor_or_customer_id: this.companyMarked.id,
          }).then(() => {
            if (this.$route.name === 'customer') {
              totalInvoices.debt -= numberInvoices;
            } else if (this.$route.name === 'vendor') {
              totalInvoices.receivable_debt -= numberInvoices;
            }
            localStorage.setItem('totalInvoices', JSON.stringify(totalInvoices));
            this.setState({ totalInvoices });
            this.$bus.emit('reload-dashboard');
            this.$bus.emit('on-unselect-items');
            this.$modal.hide('invoice-paid-modal', { isOk: true });
          }).finally(() => {
            setTimeout(() => {
              this.isLoading = false;
            }, 500);
          });
        }
      });
    },
    onOk() {
      this.$refs.form.submit();
    },
    beforeClose() {
      this.formModel = {
        date_confirm: null,
      };
      this.invoicesId = new Set();
      this.markedInvoices = new Map();
    },
    beforeOpen(params) {
      this.invoicesId = params.model;
      this.markedInvoices = new Map([...params.markedInvoices]);
      this.formModel.email = this.companyMarked.latest_emails ? this.companyMarked.latest_emails.split(';').map(email => ({ text: email })) : [];
    },
  },
};
</script>
<style lang="scss">
  .paid-modal-content {
    .paid-modal-information {
      padding: 16px;
      margin-bottom: 12px;
      border-radius: 12px;
      gap: 8px;
      display: flex;
      flex-direction: column;
      color: #003AAB;
      background: #CCE4F6;
      p {
        margin: 0;
      }
      //strong {
      //  font-weight: bold;
      //}
    }
  }
</style>



// WEBPACK FOOTER //
// src/portal-components/invoice/invoice-paid-modal.vue